class SocialSharePopup {
	init() {
		$('.social-links__link').on('click', this.triggerSocialSharePopup);
		$('.social-links__copy').on('click', this.triggerCopySocialLink);
	}

	// Trigger social share popup
	triggerSocialSharePopup(e: { preventDefault: () => void }) {
		e.preventDefault();
		const href = $(this).attr('href');
		const intWidth = '500';
		const intHeight = '400';
		const strResize = 'no';
		const strTitle =
			typeof $(this).attr('title') !== 'undefined' ? $(this).attr('title') : 'Social Share';
		const strParam = 'width=' + intWidth + ',height=' + intHeight + ',resizable=' + strResize;

		const w = window.open(href, strTitle, strParam);
		if (w) {
			w.focus();
		}
	}

	// Trigger copy social link
	triggerCopySocialLink(e: { preventDefault: () => void }) {
		e.preventDefault();
		const copyLinkUrl = document.querySelector('.social-links__copy');
		if (copyLinkUrl instanceof HTMLAnchorElement) {
			navigator.clipboard.writeText(copyLinkUrl?.href);
		}
	}
}

export default new SocialSharePopup();
